module.exports = __webpack_public_path__ + "static/mari-min-3ea7abc5263cf9bfc03b88a759878df9.png";